import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {APIConfig} from '../app.constant';
import {Observable} from 'rxjs/Observable';
import {Question} from '../models/question.model';
import {HttpHeaders} from '@angular/common/http';
import {SessionService} from './session.service';

@Injectable()
export class QuestionService extends BaseService {

  getQuestions(): Observable<Question[]> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get<Question[]>(APIConfig.API_QUESTION_URL, this.options);
  }

}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/question.service.ts